const Percen = (
    numerator: number | string,
    denominator: number | string
): string => {
    const percentage = (Number(numerator) / Number(denominator)) * 100
    return percentage.toFixed(2)
}

export default Percen
